module.exports = __webpack_public_path__ + "static/media/biket_white.dff0ed86.svg";